import React from 'react';
import { BadgeAlt as Badge } from '@cargomatic/ui';
function getColor(status) {
    switch (status) {
        case 'incomplete':
        case 'billing_hold':
            return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200';
        case 'ready_to_bill':
            return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200';
        case 'audited':
        case 'invoiced':
            return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200';
        default:
            return 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200';
    }
}
function titleCase(s) {
    return s.replace(/_/g, ' ').replace(/\b\w/g, (m) => m.toUpperCase());
}
export default function OrderBillingStatus({ className = '', billingStatus, }) {
    const status = billingStatus !== null && billingStatus !== void 0 ? billingStatus : 'incomplete';
    return (React.createElement(Badge, { className: `${getColor(status)} ${className}` }, titleCase(status)));
}
